import React from "react";
import { CalendarSyncManager } from "../../features/calendar/components/CalendarSyncManager";

const AppShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div
    data-testid="app-shell"
    className="fixed inset-0 h-dvh w-full bg-app text-text flex flex-col overflow-hidden overscroll-none"
  >
    {/* Calendar auto-sync manager (headless - renders nothing) */}
    {/* Auto-sync is OFF by default; enable via Settings when connected */}
    <CalendarSyncManager autoEnable={false} />

    {/* Main content - full screen */}
    <main className="flex-1 min-h-0 overflow-hidden">
      {children}
    </main>
  </div>
);

export default AppShell;
